import apiService from '../apiService';
import ApplicationModel from '@/pages/apps/applications/models/ApplicationModel';

export const addTagTypes = ['Applications_List', 'Application_Detail','DashboardStats','Plans_List','Addresses_List'] as const;

export const applicationsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({

		endpoints: (build) => ({
			getApplicationsList: build.query<any, any>({
				query: () => ({
					url: `application`
				}),
				providesTags: ['Applications_List']
			}),
			getApplicationDetail: build.query<any, any>({
				query: (applicationId) => ({
					url: `application/show/${applicationId}`
				}),
				providesTags: ['Application_Detail']
			}),
			createApplication: build.mutation<any, any>({
				query: (newApplication) => {
					// If it's FormData, use it directly; otherwise use ApplicationModel
					const body = newApplication instanceof FormData 
						? newApplication 
						: ApplicationModel(newApplication);
					return {
						url: `application/store`,
						method: 'POST',
						body
					};
				},
				invalidatesTags: ['Applications_List']
			}),
			updateApplication: build.mutation<any, any>({
				query: (newApplication) => {
					// If it's FormData, use it directly; otherwise use ApplicationModel
					const body = newApplication instanceof FormData 
						? newApplication 
						: ApplicationModel(newApplication);
					return {
						url: `application/update`,
						method: 'POST',
						body
					};
				},
				invalidatesTags: ['Applications_List']
			}),
			updateOrder: build.mutation<any, any>({
				query: (newApplication) => ({
					url: `order/update`,
					method: 'PUT',
					body: ApplicationModel(newApplication)
				}),
				invalidatesTags: ['Applications_List', 'Application_Detail']
			}),
			updateApplicationStatus: build.mutation<any, any>({
				query: (data) => ({
					url: `application/change-status`,
					method: 'POST',
					body: data
				}),
				invalidatesTags: ['Applications_List']
			}),
			deleteApplication: build.mutation<any, any>({
				query: (applicationId) => ({
					url: `/application/delete/${applicationId}`,
					method: 'DELETE'
				}),
				invalidatesTags: ['Applications_List','DashboardStats','Plans_List','Addresses_List']
			}),
			analyzeImage: build.mutation<any, any>({
				query: (formData) => ({
					url: `analyzeImage`,
					method: 'POST',
					body: formData
				})
			})
		})
	});

export const {
	useGetApplicationsListQuery,
	useGetApplicationDetailQuery,
	useCreateApplicationMutation,
	useUpdateOrderMutation,
	useUpdateApplicationStatusMutation,
	useDeleteApplicationMutation,
	useUpdateApplicationMutation,
	useAnalyzeImageMutation
} = applicationsApi;

export type ApplicationObjcet = {
	id: number;
	application_number: string;
	applicant_id: number;
	application_status: string;
	apply_date: string;
	approval_date: string | null;
	change_status_date: string;
	apply_date_formatted: string;
	approval_date_formatted: string | null;
	change_status_date_formatted: string;
	applicant: {
		id: number;
		name: string;
		email: string;
	};
	details: {
		id: number;
		application_id: number;
		area: string;
		item_name: string;
		condition: string;
		model: string;
		purchased_cost: number;
		current_cost: number;
		image: string;
		purchased_date: string;
		product_image: string;
		purchased_date_formatted: string;
		other_area?: string;
		other_line_item_name?: string;
	}[];
};
